(() => {
  'use strict';
  const boot = root => {
    root.querySelectorAll('[data-st-language]').forEach(select => {
      if (select.dataset.stReady) return;
      select.dataset.stReady = 'true';
      const button = select.form.querySelector('.st-language-submit');
      if (button) button.hidden = true;
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    root.querySelectorAll('[data-st-menu]').forEach(menu => {
      if (menu.dataset.stReady) return;
      menu.dataset.stReady = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('keydown', e => { if (e.key === 'Escape' && menu.open) { menu.open = false; summary.focus(); } });
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.open = false; }));
      document.addEventListener('click', e => { if (menu.open && !menu.contains(e.target)) menu.open = false; });
    });
    const current = new URL(location.href);
    root.querySelectorAll('.st-nav a').forEach(a => { if (new URL(a.href).pathname === current.pathname) a.setAttribute('aria-current', 'page'); });
  };
  boot(document);
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
